import { type FunctionComponent } from "react";

export const AboutPdfViewer: FunctionComponent = () => (
  <>
    <p>
      Renders <a href="https://en.wikipedia.org/wiki/PDF">PDFs</a>.
    </p>
    <p>
      Documents can be printed from the <b>File</b> menu.
    </p>
  </>
);
